import React, { Component } from 'react';

const UploadDocuments = () => {
	return ( <h1>Upload Documents</h1> );
}
 
export default UploadDocuments;